import { render, staticRenderFns } from "./_CustomizeTableModal.vue?vue&type=template&id=25498482&scoped=true&"
import script from "./_CustomizeTableModal.vue?vue&type=script&lang=js&"
export * from "./_CustomizeTableModal.vue?vue&type=script&lang=js&"
import style0 from "./_CustomizeTableModal.vue?vue&type=style&index=0&id=25498482&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25498482",
  null
  
)

export default component.exports